import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  openModal,
  closeModal
} from 'actions/modals'
import { INVALID_BROWSER_MODAL } from 'constants/modals'
import InvalidBrowserModal from 'components/InvalidBrowserModal'
import Bowser from 'bowser'
import { SUPPORTED_BROWSERS } from 'constants/supportedBrowsers'

class BrowserValidatorContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isValidBrowser: null
    }
  }

  componentDidMount() {
    const browser = Bowser.getParser(window.navigator.userAgent)
    const os = browser.getOSName().toLowerCase()
    const browserName = browser.getBrowserName().toLowerCase()
    const isValidIOSWebView = os === 'ios' && parseFloat(browser.getOSVersion()) >= 14.3
      && browserName === 'safari' && browser.getBrowserVersion() === undefined
    const isValid = browser.satisfies(SUPPORTED_BROWSERS) || isValidIOSWebView
    this.setState({ isValidBrowser: !!isValid, os: os, browser: browserName })
    if (!isValid) this.props.openModal()
  }

  render() {
    const {
      closeModal,
      modalOpened,
      children
    } = this.props

    if (this.state.isValidBrowser === null) {
      return null
    }

    if (this.state.isValidBrowser) {
      return (
        <div>
          {children}
        </div>
      )
    } else {
      return (
        <InvalidBrowserModal
          show={modalOpened}
          closeModal={closeModal}
          isValidBrowser={this.state.isValidBrowser}
          os={this.state.os}
          currBrowser={this.state.browser}
        />
      )
    }
  }
}

function mapStateToProps (state) {
  return {
    modalOpened: state.modal.currentModal === INVALID_BROWSER_MODAL
  }
}

function mapDispatchToProps (dispatch) {
  return {
    openModal: () => dispatch(openModal(INVALID_BROWSER_MODAL)),
    closeModal: () => dispatch(closeModal(INVALID_BROWSER_MODAL))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BrowserValidatorContainer)